import React, { useState } from 'react';
import styled from 'styled-components';
import pizza17 from '../images/pizza17.webp';
import pizza18 from '../images/pizza18.webp';
import pizza19 from '../images/pizza19.webp';
import pizza22 from '../images/pizza22.webp';
import pizza23 from '../images/pizza23.webp';
import pizza24 from '../images/pizza24.webp';
import pizza26 from '../images/pizza26.webp';
import pizza27 from '../images/pizza27.webp';
import pizza28 from '../images/pizza28.webp';
import pizza57 from '../images/pizza57.webp';

const GalleryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.2rem;
  padding: 1rem 0 3rem;
`;

const PhotoWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  min-height: 220px;
  cursor: pointer;
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.12);
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 22px 50px rgba(0, 0, 0, 0.18);
  }
`;

const PhotoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;

  ${PhotoWrapper}:hover & {
    transform: scale(1.03);
  }
`;

const FullscreenOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
`;

const FullscreenImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 16px;
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.4);
`;

const CloseArea = styled.div`
  position: absolute;
  inset: 0;
  cursor: pointer;
`;

function PizzaGallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    pizza17,
    pizza18,
    pizza19,
    pizza22,
    pizza23,
    pizza24,
    pizza26,
    pizza27,
    pizza28,
    pizza57,
  ];

  const openImage = (src) => {
    setSelectedImage(src);
    document.documentElement.style.overflow = 'hidden';
  };

  const closeImage = () => {
    setSelectedImage(null);
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <GalleryContainer>
        {galleryImages.map((src, index) => (
          <PhotoWrapper key={index} onClick={() => openImage(src)}>
            <PhotoImage src={src} alt={`Pizza ${index + 1}`} />
          </PhotoWrapper>
        ))}
      </GalleryContainer>

      {selectedImage && (
        <FullscreenOverlay onClick={closeImage}>
          <CloseArea />
          <FullscreenImage src={selectedImage} alt="Podgląd pizzy" />
        </FullscreenOverlay>
      )}
    </>
  );
}

export default PizzaGallery;
